import type {
  CorridorCalendarGridInput,
  CorridorCalendarGridResult,
  CorridorDraftInput,
  CorridorOpportunity,
  CorridorOpportunityDecision,
  CorridorOpportunityListResult,
  CorridorOpportunityStatus,
} from '~/types/corridorOpportunity';

import { request } from './common';

interface ApiResponse<T> {
  status: number;
  result: T;
}

const basePath = () => `${window.configs.API_HOST}/api/flights/corridor-opportunities`;

export async function getCorridorCalendarGrid(input: CorridorCalendarGridInput): Promise<CorridorCalendarGridResult> {
  const response = (await request(`${window.configs.API_HOST}/api/flights/calendar-grid`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })) as ApiResponse<CorridorCalendarGridResult>;
  return response.result;
}

export async function listCorridorOpportunities(
  statuses: Array<CorridorOpportunityStatus> = [],
  options: { signal?: AbortSignal } = {},
): Promise<CorridorOpportunityListResult> {
  const statusQuery = statuses.length ? `?status=${encodeURIComponent(statuses.join(','))}` : '';
  const response = (await request(`${basePath()}${statusQuery}`, {
    method: 'GET',
    signal: options.signal,
  })) as ApiResponse<CorridorOpportunityListResult>;
  return response.result;
}

export async function getCorridorOpportunity(
  id: string,
  options: { signal?: AbortSignal } = {},
): Promise<CorridorOpportunity> {
  const response = (await request(`${basePath()}/${id}`, {
    method: 'GET',
    signal: options.signal,
  })) as ApiResponse<CorridorOpportunity>;
  return response.result;
}

export async function decideCorridorOpportunity(
  id: string,
  decision: CorridorOpportunityDecision,
): Promise<CorridorOpportunity> {
  const response = (await request(`${basePath()}/${id}/decision`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(decision),
  })) as ApiResponse<CorridorOpportunity>;
  return response.result;
}

export async function createCorridorOpportunityDraft(
  id: string,
  input: CorridorDraftInput,
): Promise<CorridorOpportunity> {
  const response = (await request(`${basePath()}/${id}/draft`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })) as ApiResponse<CorridorOpportunity>;
  return response.result;
}
